import { ArrowRight } from "@phosphor-icons/react";

import { FAQS } from "./copy";

export function FaqSection() {
  return (
    <section className="border-border-subtle border-t bg-white" aria-labelledby="faq-heading">
      <div className="mx-auto grid max-w-[1120px] gap-10 px-5 py-16 sm:px-8 sm:py-20 lg:grid-cols-[0.72fr_1.28fr] lg:px-10">
        <div>
          <p className="text-accent mb-3 text-[12px] tracking-[0.1em] uppercase">Your questions</p>
          <h2
            id="faq-heading"
            className="text-primary text-[32px] leading-[1.16] tracking-[-0.02em] sm:text-[38px]"
          >
            What happens to your network details?
          </h2>
          <p className="text-muted mt-4 max-w-[390px] text-[15px] leading-6">
            A straightforward explanation of what the connectors do, and what they do not do.
          </p>
        </div>
        <div className="border-border-subtle border-t">
          {FAQS.map((faq) => (
            <details key={faq.question} className="group border-border-subtle border-b">
              <summary className="text-primary focus-visible:outline-ring flex cursor-pointer list-none items-center justify-between gap-5 py-5 text-[16px] leading-6 focus-visible:outline-2 focus-visible:outline-offset-2 [&::-webkit-details-marker]:hidden">
                {faq.question}
                <span className="border-border text-muted group-open:bg-primary flex size-7 shrink-0 items-center justify-center rounded-full border text-[18px] transition group-open:rotate-45 group-open:text-white">
                  +
                </span>
              </summary>
              <p className="text-muted max-w-[650px] pr-8 pb-6 text-[14px] leading-6">
                {faq.answer}
              </p>
            </details>
          ))}
          <a
            href="https://www.pusr.com/products/rs232-rs485-to-wifi-converters-usr-w610.html"
            target="_blank"
            rel="noreferrer"
            className="text-primary decoration-border-strong hover:decoration-primary focus-visible:outline-ring mt-5 inline-flex items-center gap-2 text-[13px] underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-4"
          >
            View the USR-W610 manufacturer specifications
            <ArrowRight className="size-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
